import api from "./api";

// 响应参数
export interface VideoRetryFailedTemplateResponse {
  id: string;
  model_id?: string;
  name: string;
  gender: string;
  age_group: string;
  is_hd: boolean;
  is_pro: boolean;
  is_exclusive_pro: boolean;
  is_free_speech: boolean;
  situation: string;
  image_url: string;
  compressed_actor_default_video_url?: string;
  full_actor_default_video_url?: string;
  sort_order: number;
  is_favorite: boolean;
  is_my_actor: boolean;
  is_free: string;
  tags?: Array<string>;
  generate_status: number;
  generate_type: number;
  default_audio: Default_audio;
  created_at: string;
};

export interface Default_audio {
  id: string;
  type: number;
  actor_id: string;
  voice_tts_id: string;
  model_name: string;
  name: string;
  age_group: string;
  language: string;
  emotion: string;
  gender: string;
  speed: number;
  audio_url: string;
  duration: number;
  is_starred: boolean;
  is_selected: boolean;
  sort_order: number;
  use_count: number;
};

/** 自定义演员失败重试接口 */
export const videoRetryFailedTemplate = async (id: string) => {
  const res = await api.post<VideoRetryFailedTemplateResponse>('/video/retry-failed-template', {
    template_id: id
  });
  return res.data;
}
